const config = {
  //backendUrl: "http://localhost:3001/api",
  backendUrl: "https://backend.handpik.ai/api",
};

export default config;
